import { render, staticRenderFns } from "./PraticheDataTable.vue?vue&type=template&id=2c6cc910&scoped=true"
import script from "./PraticheDataTable.vue?vue&type=script&lang=js"
export * from "./PraticheDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6cc910",
  null
  
)

export default component.exports